module.exports = __webpack_public_path__ + "img/april-red.5a23d768.svg";